// DueDateCalculator.js
import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import {
  SecondAds,
  FirstAds,
  MobileUnderCalAds,
} from "../../Ads";
import { SERVER_URL } from "./ConstantsWomenCalculator";
import { DueDate_EndPoint } from "./ConstantsWomenCalculator";
import { CyrcleLengthcomponet } from "./Component";
import { DueDateTable } from "./Tables";
import SharedHelmet from "../Helmet";
const TITLE = "Kalkulator Tanggal Perkiraan Lahir";
const DESCRIPTION =
  "Kalkulator tanggal lahir: Tentukan tanggal jatuh tempo Anda dengan akurat! Masukkan tanggal haid terakhir (LMP) atau tanggal pembuahan untuk mengetahui tanggal perkiraan lahir - dengan penjelasan tahap kehamilan per minggu dan bulan!";
const KEYWORDS = "tanggal lahir, hitung tanggal lahir, tanggal perkiraan lahir";
const OG_URL = "https://do-calculate.com/calculator/id/pregnancy-due-date/";
const apiEndpoint = `${SERVER_URL}/${DueDate_EndPoint}`;
function DueDate() {
  const [firstDayOfLastPeriod, setFirstDate] = useState();
  const [periodLength, setPeriodLength] = useState(1);
  const [cycleLength, setCyrcleLength] = useState(28);
  const [result, setRestul] = useState(null);
  const [error, setError] = useState(null);
  const [statusCode, setStatusCode] = useState(null);
  const [classification, setClassification] = useState(null);
  const handleDateChange = (event) => {
    setFirstDate(event.target.value);
  };
  const calculateDueDate = async () => {
    try {
      const response = await fetch(apiEndpoint, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          firstDayOfLastPeriod,
          cycleLength,
          periodLength,
        }),
      });
      const data = await response.json();
      setStatusCode(response.status);
      if (response.ok) {
        setRestul(data.result);
        setError(null);
      } else {
        setRestul(null);
        setError(data.error);
      }
    } catch (error) {
      console.error(error);
    }
  };
  return (
    <div>
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{fontSize:'18px'}}> Hitung Tanggal Lahir </h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                Kehamilan berlangsung rata-rata 280 hari (40 minggu) dari hari pertama haid terakhir Anda (LMP). Hari pertama menstruasi dianggap sebagai hari pertama kehamilan, meskipun Anda mungkin baru hamil setelah sekitar dua minggu (perkembangan janin tertunda dua minggu dari tanggal kehamilan). Menghitung tanggal lahir Anda bukanlah ilmu pasti. Sangat sedikit wanita yang benar-benar melahirkan pada tanggal perkiraan lahir mereka. Meskipun Anda perlu memiliki gambaran tentang kapan bayi Anda akan lahir, perkirakan banyak faktor yang mempengaruhi tanggal perkiraan lahir. Untuk menghitung perkiraan tanggal lahir, Anda perlu mengetahui hari pertama haid terakhir Anda untuk menggunakan kalkulator ini. Jika Anda tidak mengetahuinya atau tidak yakin, bicarakan dengan dokter Anda.
                <hr />
              </div>
              <br />
            </div>
            <MobileUnderCalAds />
            <div className="row">
              <div className="col-12 col-md-5 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  Kalkulator Tanggal Lahir
                </div>
                <hr />
                <br />
                <div className=" form-group d-flex align-items-center">
                  <b>
                    {" "}
                    <label className="form-label ms-2">
                      <strong>Hari pertama</strong> haid terakhir
                    </label>
                  </b>
                  <br />
                  <input
                    type="date"
                    id="weightNumber"
                    value={firstDayOfLastPeriod}
                    onChange={handleDateChange}
                    className="form-control ml-2"
                    style={{ width: "145px" }}
                    placeholder="175"
                  />
                </div>
                <br />
                <div className="form-group d-flex align-items-center">
                  <b>
                    {" "}
                    <label htmlFor="CycleLength" className="form-label ms-2">
                      Rata-rata waktu antar siklus
                    </label>
                  </b>
                  <CyrcleLengthcomponet handleDateChange={setCyrcleLength} />
                  <div className="input-group-append">
                    <span className="input-group-text ">Hari</span>
                  </div>
                </div>
                <br />
                <hr />
                <div>
                  <button
                    className="btn btn-success"
                    style={{ fontSize: "20px" }}
                    onClick={calculateDueDate}
                  >
                    Hitung{" "}
                  </button>
                </div>
              </div>
              <div className="col-12 col-md-7">
                <br />
                {statusCode === 400 && (
                  <div className="alert alert-warning">
                    <b>
                      <u> Terjadi Kesalahan :</u>
                    </b>{" "}
                    Harap masukkan semua kolom dengan benar.{" "}
                  </div>
                )}
                {result && (
                  <div>
                    <h4>
                      <div className="p-3 mb-2 bg-success text-white">
                        Hasil:{" "}
                      </div>
                    </h4>
                    <hr />
                    <DueDateTable result={result}></DueDateTable>
                  </div>
                )}
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">Deskripsi Kalkulator Tanggal Lahir : </div>
              <div className="info-section-body">
                <u>
                  <h2>Memperkirakan Tanggal Jatuh Tempo</h2>{" "}
                </u>
                <br />
                Tanggal jatuh tempo, juga dikenal sebagai perkiraan tanggal lahir, adalah perkiraan kapan wanita hamil akan melahirkan. Meskipun tanggal jatuh tempo biasanya diperkirakan sebagai satu tanggal, berguna untuk mempertimbangkan rentang tanggal jatuh tempo, karena hanya 4% kelahiran terjadi pada tanggal perkiraan jatuh tempo.
                <br/>                Tanggal jatuh tempo dapat diperkirakan menggunakan beberapa metode berbeda, termasuk haid terakhir, ultrasound, tanggal pembuahan, dan tanggal transfer embrio (IVF).
                <br/>                <u>
                  <b>Haid Terakhir</b>{" "}
                </u>
                <br />
                Asumsi default konverter ini didasarkan pada haid terakhir wanita (LMP), berdasarkan asumsi bahwa kelahiran rata-rata terjadi pada usia kehamilan (usia kehamilan dihitung dari haid terakhir wanita) yaitu 280 hari atau 40 minggu. Meskipun ada beberapa perdebatan tentang kapan kehamilan secara teknis dimulai, baik saat pembuahan sel telur (fertilisasi) atau saat sel telur menempel di rahim (implantasi), usia kehamilan tidak berubah berdasarkan definisi kehamilan yang berbeda karena didasarkan pada haid terakhir. Dalam hal usia kehamilan, kehamilan biasanya berlangsung antara 37 dan 42 minggu, dengan 40 minggu digunakan sebagai perkiraan umum dalam perhitungan.
                <br/>                <u>
                  <b>Tanggal Jatuh Tempo sebagai Titik Referensi</b>{" "}
                </u>
                <br />
                Secara umum, waktu kelahiran bayi dalam rentang waktu 37 hingga 42 minggu tidak perlu dikhawatirkan. Bayi yang lahir antara minggu 37-39, 39-41, dan 41-42 masing-masing dianggap lahir agak awal, tepat waktu, dan agak terlambat. Dalam kondisi normal, bayi dapat lahir dalam periode ini dengan kesehatan yang baik, meskipun bayi yang lahir tepat waktu umumnya memiliki hasil yang lebih baik. Bayi yang lahir sebelum minggu 37 dianggap prematur, sedangkan bayi yang lahir setelah minggu 42 dianggap terlambat. Periode ini penting sebagai titik referensi bagi dokter untuk menentukan apakah diperlukan tindakan. Misalnya, jika seorang wanita mengalami persalinan sangat dini pada minggu 33, dokter dapat menghentikan persalinan untuk menghindari kelahiran bayi prematur yang dapat menderita berbagai masalah kesehatan akibat keterlambatan perkembangan. Sebaliknya, jika seorang wanita tidak melahirkan setelah minggu 42, dokter dapat menginduksi persalinan. Salah satu komplikasi potensial dari membiarkan kehamilan berlanjut setelah minggu 42 adalah bahwa plasenta, yang bertanggung jawab untuk menyediakan nutrisi dan oksigen bagi bayi, dapat berhenti berfungsi dengan baik, sementara bayi terus tumbuh (membutuhkan lebih banyak nutrisi dan oksigen), yang pada akhirnya akan mengakibatkan titik kritis.
                <br/>                <hr />
                <b>Tanggal peninjauan terakhir : </b>
                28/02/2026
              </div>
            </div>
          </div>
        </div>
         </div>
</div>
  );
}
export default DueDate;